import { render, staticRenderFns } from "./SignupProfilePage.vue?vue&type=template&id=ec1fc068"
import script from "./SignupProfilePage.vue?vue&type=script&lang=js"
export * from "./SignupProfilePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports